import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "row mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = {
  key: 0,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 1,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_12 = { class: "col p-0" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_16 = { class: "col p-0" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_19 = { class: "col p-0" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_22 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_23 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_24 = { class: "col p-0" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_27 = { class: "col p-0" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = {
  key: 2,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_30 = { class: "col p-0" }
const _hoisted_31 = { class: "" }
const _hoisted_32 = {
  key: 3,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_33 = { class: "col p-0" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = {
  key: 4,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_36 = { class: "col p-0" }
const _hoisted_37 = { class: "form-check small mb-0" }
const _hoisted_38 = {
  class: "form-check-label",
  for: "isDeleted"
}
const _hoisted_39 = {
  key: 5,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_40 = { class: "col p-0" }
const _hoisted_41 = { class: "" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = {
  key: 6,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_44 = { class: "col p-0" }
const _hoisted_45 = { class: "" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = { class: "form-group mb-2 col" }
const _hoisted_48 = { class: "col-auto p-0 text-end" }
const _hoisted_49 = { class: "col-sm-12" }
const _hoisted_50 = { class: "card card-body" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-sm-12 mb-3" }
const _hoisted_53 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_54 = { class: "mb-0" }
const _hoisted_55 = { class: "form-group col-sm-12" }
const _hoisted_56 = { class: "mt-3" }
const _hoisted_57 = { class: "table table-striped border-light" }
const _hoisted_58 = { class: "text-capitalize" }
const _hoisted_59 = { class: "text-capitalize" }
const _hoisted_60 = { class: "text-capitalize" }
const _hoisted_61 = { class: "text-capitalize" }
const _hoisted_62 = {
  key: 0,
  class: "text-capitalize"
}
const _hoisted_63 = { class: "text-nowrap" }
const _hoisted_64 = { class: "d-flex flex-column" }
const _hoisted_65 = { class: "fw-bold" }
const _hoisted_66 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_67 = { class: "d-flex flex-column" }
const _hoisted_68 = { class: "text-muted" }
const _hoisted_69 = { class: "text-danger" }
const _hoisted_70 = { class: "text-success" }
const _hoisted_71 = { class: "d-flex flex-column" }
const _hoisted_72 = { class: "text-capitalize-first" }
const _hoisted_73 = { class: "text-muted" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "d-flex flex-column" }
const _hoisted_76 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_77 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_78 = {
  key: 0,
  class: "d-flex flex-wrap gap-3 small text-muted mb-2"
}
const _hoisted_79 = { class: "overflow-auto" }
const _hoisted_80 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_81 = {
  key: 0,
  style: {"width":"0"}
}
const _hoisted_82 = {
  key: 1,
  class: "text-capitalize-first"
}
const _hoisted_83 = {
  key: 2,
  class: "text-capitalize-first"
}
const _hoisted_84 = { class: "text-capitalize-first" }
const _hoisted_85 = { class: "text-capitalize-first" }
const _hoisted_86 = { class: "text-capitalize-first" }
const _hoisted_87 = { class: "text-capitalize-first" }
const _hoisted_88 = { class: "text-capitalize-first" }
const _hoisted_89 = { class: "text-capitalize-first" }
const _hoisted_90 = { class: "text-capitalize-first" }
const _hoisted_91 = {
  class: "text-capitalize-first text-wrap",
  style: {"width":"0"}
}
const _hoisted_92 = { class: "text-capitalize-first" }
const _hoisted_93 = {
  key: 0,
  style: {"width":"0"}
}
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { key: 2 }
const _hoisted_96 = { class: "d-flex flex-row align-items-center gap-2 mt-1 mb-1" }
const _hoisted_97 = { class: "d-flex flex-column" }
const _hoisted_98 = { class: "" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { key: 2 }
const _hoisted_102 = { class: "text-secondary" }
const _hoisted_103 = ["href"]
const _hoisted_104 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_105 = ["href"]
const _hoisted_106 = ["href"]
const _hoisted_107 = ["title"]
const _hoisted_108 = ["title"]
const _hoisted_109 = ["title"]
const _hoisted_110 = { key: 7 }
const _hoisted_111 = { class: "text-secondary" }
const _hoisted_112 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_113 = ["title"]
const _hoisted_114 = { class: "d-flex flex-row justify-content-between align-items-center" }
const _hoisted_115 = { class: "d-flex flex-column" }
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = { key: 2 }
const _hoisted_119 = ["onClick"]
const _hoisted_120 = {
  class: "d-flex flex-column",
  style: {"width":"200px"}
}
const _hoisted_121 = ["title"]
const _hoisted_122 = { class: "justify-content-center d-flex position-absolute w-100" }
const _hoisted_123 = ["title"]
const _hoisted_124 = { class: "justify-content-center d-flex position-absolute w-100" }
const _hoisted_125 = {
  class: "d-flex flex-column",
  style: {"width":"100px"}
}
const _hoisted_126 = ["title"]
const _hoisted_127 = {
  key: 0,
  class: "justify-content-center d-flex position-absolute w-100"
}
const _hoisted_128 = {
  key: 1,
  class: "justify-content-center d-flex position-absolute w-100"
}
const _hoisted_129 = ["title"]
const _hoisted_130 = {
  key: 0,
  class: "justify-content-center d-flex position-absolute w-100"
}
const _hoisted_131 = {
  key: 1,
  class: "justify-content-center d-flex position-absolute w-100"
}
const _hoisted_132 = { key: 0 }
const _hoisted_133 = { key: 1 }
const _hoisted_134 = { class: "form-check form-switch d-flex align-items-center form-check-success" }
const _hoisted_135 = ["title", "onUpdate:modelValue", "onChange"]
const _hoisted_136 = { class: "text-end" }
const _hoisted_137 = ["onClick"]
const _hoisted_138 = ["onClick", "title"]
const _hoisted_139 = ["onClick"]
const _hoisted_140 = ["onClick"]
const _hoisted_141 = ["onClick"]
const _hoisted_142 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_DeviceList = _resolveComponent("DeviceList")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_GroupsList = _resolveComponent("GroupsList")!
  const _component_RequisitesForm = _resolveComponent("RequisitesForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_RequisitesPayInDealSumsForm = _resolveComponent("RequisitesPayInDealSumsForm")!
  const _component_DeviceLabel = _resolveComponent("DeviceLabel")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_RequisiteFillStatusDot = _resolveComponent("RequisiteFillStatusDot")!
  const _component_RequisiteSumProgress = _resolveComponent("RequisiteSumProgress")!
  const _component_b_progress_bar = _resolveComponent("b-progress-bar")!
  const _component_b_progress = _resolveComponent("b-progress")!
  const _component_Sortable = _resolveComponent("Sortable")!
  const _component_DeviceMessageLogsModal = _resolveComponent("DeviceMessageLogsModal")!
  const _component_BlacklistMethodAgreementModal = _resolveComponent("BlacklistMethodAgreementModal")!
  const _component_TraderRequisitesSettingsModal = _resolveComponent("TraderRequisitesSettingsModal")!
  const _component_CounterpartiesModal = _resolveComponent("CounterpartiesModal")!
  const _component_CounterpartiesImportModal = _resolveComponent("CounterpartiesImportModal")!
  const _component_FraudexCheckModal = _resolveComponent("FraudexCheckModal")!
  const _component_FraudexFeedbackModal = _resolveComponent("FraudexFeedbackModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.id'),
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.id) = $event))
                            }, null, 8, _hoisted_10), [
                              [_vModelText, _ctx.requestDTO.id]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.requisites'),
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.query) = $event))
                            }, null, 8, _hoisted_14), [
                              [_vModelText, _ctx.requestDTO.query]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_Multiselect, {
                          id: "currencies",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.currencies,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.currencies) = $event)),
                          options: _ctx.currencyList,
                          "custom-label": (opt) => `${opt}`,
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.currencies')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_Multiselect, {
                          id: "methods",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.methods,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
                          options: _ctx.methodList(),
                          "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.payment_methods')
                        }, {
                          option: _withCtx((props) => [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_PayMethodIcon, {
                                "icon-class": "icon",
                                method: props.option
                              }, null, 8, ["method"]),
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_Multiselect, {
                          id: "options",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.options,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                          options: _ctx.store.getters['currencyMethods/options'](),
                          "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.payment_options')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_Multiselect, {
                          id: "statused",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.statuses,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                          options: [1, 0],
                          "custom-label": (opt) => opt === 1 ? _ctx.helper.trans('requisites.active') : _ctx.helper.trans('requisites.inactive'),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.status')
                        }, null, 8, ["modelValue", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  (_ctx.isTrader || _ctx.isTraderOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_Multiselect, {
                              id: "group",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.groupId,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.groupId) = $event)),
                              options: _ctx.store.getters['reqGroups/ids'],
                              "custom-label": (opt) => _ctx.store.getters['reqGroups/get'](opt)?.name,
                              multiple: false,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.req_group')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isOperator || _ctx.isAdmin || _ctx.isTeamLead)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_TraderMultiselect, {
                              multiple: true,
                              modelValue: _ctx.tradersFilter,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tradersFilter) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isOperator || _ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.isDeleted) = $event)),
                              "true-value": "true",
                              type: "checkbox",
                              value: "",
                              id: "isDeleted"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.requestDTO.isDeleted]
                            ]),
                            _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.helper.trans('labels.deleted')), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.from_sum'),
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestDTO.minAmount) = $event))
                            }, null, 8, _hoisted_42), [
                              [_vModelText, _ctx.requestDTO.minAmount]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.to_sum'),
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestDTO.maxAmount) = $event))
                            }, null, 8, _hoisted_46), [
                              [_vModelText, _ctx.requestDTO.maxAmount]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("h5", _hoisted_54, _toDisplayString(_ctx.helper.trans('labels.requisites')), 1),
                      _createElementVNode("div", null, [
                        (_ctx.isAdmin || _ctx.isOperator)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.counterpartiesImportModal?.show())),
                              class: "btn btn-outline-secondary btn-sm text-capitalize-first me-2"
                            }, [
                              _cache[44] || (_cache[44] = _createElementVNode("i", { class: "fa fa-link me-1" }, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.helper.trans(_ctx.storeCounterpartyAllowlistEnabled ? 'counterparty_import.action_allowlist' : 'counterparty_import.action')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showImportModal())),
                              class: "btn btn-outline-secondary btn-sm text-capitalize-first me-2"
                            }, [
                              _cache[45] || (_cache[45] = _createElementVNode("i", { class: "fa fa-file-import me-1" }, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.import')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin || _ctx.isOperator)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$refs.traderRequisitesSettingsModal.openModal())),
                              class: "btn btn-outline-primary btn-sm text-capitalize-first"
                            }, [
                              _cache[46] || (_cache[46] = _createElementVNode("i", { class: "fa fa-cog me-1" }, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('button.plan_settings')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    (_ctx.isTrader || _ctx.isTraderOperator)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showDevicesModal())),
                          class: "btn btn-outline-dark btn-sm rounded-pill text-capitalize"
                        }, [
                          _cache[47] || (_cache[47] = _createElementVNode("i", { class: "fa fa-mobile-screen-button" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.devices')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isTrader || _ctx.isTraderOperator)
                      ? (_openBlock(), _createBlock(_component_b_modal, {
                          key: 1,
                          "dialog-class": "modal-lg",
                          title: _ctx.helper.trans('labels.devices'),
                          modelValue: _ctx.devicesModal,
                          "body-class": "pt-0",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.devicesModal = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DeviceList, { ref: "deviceList" }, null, 512)
                          ]),
                          footer: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.devicesModal = false)),
                              class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
                          ]),
                          _: 1
                        }, 8, ["title", "modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isTrader || _ctx.isTraderOperator)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showGroupsModal())),
                          class: "btn btn-outline-dark btn-sm ms-2 rounded-pill text-capitalize"
                        }, _toDisplayString(_ctx.helper.trans('button.groups')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isTrader || _ctx.isTraderOperator)
                      ? (_openBlock(), _createBlock(_component_b_modal, {
                          key: 3,
                          "dialog-class": "modal-lg",
                          title: _ctx.helper.trans('button.groups'),
                          modelValue: _ctx.groupsModal,
                          "body-class": "pt-0",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.groupsModal = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_GroupsList, { ref: "groupsList" }, null, 512)
                          ]),
                          footer: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.groupsModal = false)),
                              class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
                          ]),
                          _: 1
                        }, 8, ["title", "modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isTrader || _ctx.isTraderOperator)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          type: "button",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showEditModal())),
                          class: "btn btn-outline-dark btn-sm rounded-pill float-end text-capitalize"
                        }, [
                          _cache[48] || (_cache[48] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.create')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isTrader || _ctx.isTraderOperator || _ctx.isAdmin || _ctx.isOperator)
                      ? (_openBlock(), _createBlock(_component_b_modal, {
                          key: 5,
                          "dialog-class": "modal-lg",
                          title: _ctx.createModalTitle,
                          modelValue: _ctx.createModal,
                          "body-class": "pt-0",
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.createModal = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_RequisitesForm, {
                              ref: "createForm",
                              onShowCounterparties: _ctx.showCounterpartiesModal
                            }, null, 8, ["onShowCounterparties"])
                          ]),
                          footer: _withCtx(() => [
                            (_ctx.isTrader || _ctx.isTraderOperator)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.createModal = false)),
                                  class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                                }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1))
                              : _createCommentVNode("", true),
                            _createVNode(_component_LoaderWrapper, {
                              ref: "loaderCreateFrom",
                              zoom: 0.5
                            }, {
                              default: _withCtx(() => [
                                (_ctx.isTrader || _ctx.isTraderOperator)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.save())),
                                      class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                    }, _toDisplayString(_ctx.helper.trans('button.save')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.createForm?.isImport && _ctx.isAdmin)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.makeImport())),
                                      class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                    }, _toDisplayString(_ctx.helper.trans('labels.import')), 1))
                                  : _createCommentVNode("", true),
                                ((_ctx.isTrader || _ctx.isTraderOperator || _ctx.isAdmin || _ctx.isOperator) && _ctx.store.getters.getAppData?.requisitesTotalLimitEnabled && _ctx.createForm?.form?.id && _ctx.createForm?.form?.manualResetEnabled)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.resetTotalLimit())),
                                      class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                    }, _toDisplayString(_ctx.helper.trans('button.reset_total_limit')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        }, 8, ["title", "modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.hasRole([_ctx.UserRole.ADMIN, _ctx.UserRole.OPERATOR, _ctx.UserRole.TRADER, _ctx.UserRole.TRADER_OPERATOR]))
                      ? (_openBlock(), _createBlock(_component_b_modal, {
                          key: 6,
                          "dialog-class": "modal-lg",
                          title: _ctx.helper.trans('labels.history'),
                          modelValue: _ctx.historyModal,
                          "body-class": "pt-0",
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.historyModal = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("table", _hoisted_57, [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
                                    _createElementVNode("th", _hoisted_59, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                                    _createElementVNode("th", _hoisted_60, _toDisplayString(_ctx.helper.trans('labels.field')), 1),
                                    _createElementVNode("th", _hoisted_61, _toDisplayString(_ctx.helper.trans('labels.initiator')) + " / " + _toDisplayString(_ctx.helper.trans('labels.action_type')), 1),
                                    (!(_ctx.isTrader || _ctx.isTraderOperator))
                                      ? (_openBlock(), _createElementBlock("th", _hoisted_62, _toDisplayString(_ctx.helper.trans('labels.user')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedHistory, (group) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: group.changeGroupId
                                    }, [
                                      _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.dateHelper.format(group.date)), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_64, [
                                          _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.getActionDescription(group.changes)), 1),
                                          (group.changes.length > 1)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_66, " Изменено полей: " + _toDisplayString(group.changes.length), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_67, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.changes, (change) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: change.id,
                                              class: "mb-1"
                                            }, [
                                              _createElementVNode("small", null, [
                                                _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.getFieldName(change.fieldName)) + ":", 1),
                                                _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.formatValue(change.oldValue, change.fieldName)), 1),
                                                _cache[49] || (_cache[49] = _createElementVNode("i", { class: "fa fa-arrow-right mx-1 text-muted" }, null, -1)),
                                                _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.formatValue(change.newValue, change.fieldName)), 1)
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_71, [
                                          _createElementVNode("small", _hoisted_72, _toDisplayString(_ctx.helper.trans(`user_roles.${group.initiatorRole}`)), 1),
                                          _createElementVNode("small", _hoisted_73, _toDisplayString(_ctx.helper.trans(`initiator_type.${group.initiatorType}`)), 1)
                                        ])
                                      ]),
                                      (!(_ctx.isTrader || _ctx.isTraderOperator))
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_74, [
                                            _createElementVNode("div", _hoisted_75, [
                                              (group.initiator)
                                                ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                                    key: 0,
                                                    "show-badge": "",
                                                    user: group.initiator
                                                  }, null, 8, ["user"]))
                                                : (_openBlock(), _createElementBlock("small", _hoisted_76, "-"))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              (_ctx.requisitesHistoryResponse.items.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.helper.trans('labels.no_history')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.requisitesHistoryResponse.totalCount > _ctx.requisitesHistoryResponse.items.length)
                                ? (_openBlock(), _createBlock(_component_b_pagination, {
                                    key: 1,
                                    modelValue: _ctx.historyPage,
                                    "onUpdate:modelValue": [
                                      _cache[28] || (_cache[28] = ($event: any) => ((_ctx.historyPage) = $event)),
                                      _cache[29] || (_cache[29] = () => _ctx.currentRequisites && _ctx.loadRequisitesHistory(_ctx.currentRequisites))
                                    ],
                                    "total-rows": _ctx.requisitesHistoryResponse.totalCount,
                                    "per-page": _ctx.requisitesHistoryResponse.limit,
                                    limit: 20,
                                    "prev-text": "Back",
                                    "next-text": "Next",
                                    align: "start",
                                    "first-number": "",
                                    "hide-goto-end-buttons": "",
                                    "hide-ellipsis": ""
                                  }, null, 8, ["modelValue", "total-rows", "per-page"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          footer: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.historyModal = false)),
                              class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
                          ]),
                          _: 1
                        }, 8, ["title", "modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin || _ctx.isOperator)
                      ? (_openBlock(), _createBlock(_component_b_modal, {
                          key: 7,
                          "dialog-class": "modal-lg",
                          title: _ctx.helper.trans('labels.sum_limits'),
                          modelValue: _ctx.payInDealSumsModal,
                          "body-class": "pt-0",
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.payInDealSumsModal = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_RequisitesPayInDealSumsForm, {
                              ref: (el) => _ctx.payInDealSumsForm = el
                            }, null, 512)
                          ]),
                          footer: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.payInDealSumsModal = false)),
                              class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                            _createVNode(_component_LoaderWrapper, {
                              ref: (el) => _ctx.loaderPayInDealSums = el,
                              zoom: 0.5
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.savePayInDealSums())),
                                  class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        }, 8, ["title", "modelValue"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.requisites.items.some(_ctx.hasFrozenSums))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['free', 'in_progress', 'near_limit', 'limit', 'inactive'], (status) => {
                        return _createElementVNode("span", {
                          key: status,
                          class: "d-inline-flex align-items-center gap-1"
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["requisite-status-dot", 'requisite-status-dot--' + status])
                          }, null, 2),
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('requisites.status_' + status)), 1)
                        ])
                      }), 64))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("table", _hoisted_80, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        ((_ctx.isTrader || _ctx.isTraderOperator) && _ctx.reorderEnabled)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_81))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin || _ctx.isOperator)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_82, _toDisplayString(_ctx.helper.trans('labels.id')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_83, _toDisplayString(_ctx.helper.trans('labels.trader')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", _hoisted_84, _toDisplayString(_ctx.helper.trans('labels.device')), 1),
                        _createElementVNode("th", _hoisted_85, _toDisplayString(_ctx.helper.trans('labels.requisites')), 1),
                        _createElementVNode("th", _hoisted_86, _toDisplayString(_ctx.helper.trans('labels.req_group')), 1),
                        _createElementVNode("th", _hoisted_87, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                        _createElementVNode("th", _hoisted_88, _toDisplayString(_ctx.helper.trans('labels.sum_limits')), 1),
                        _createElementVNode("th", _hoisted_89, _toDisplayString(_ctx.helper.trans('labels.volume_limits')), 1),
                        _createElementVNode("th", _hoisted_90, _toDisplayString(_ctx.helper.trans('labels.count_limits')), 1),
                        _createElementVNode("th", _hoisted_91, _toDisplayString(_ctx.helper.trans('labels.concurrent_trader_count_short')), 1),
                        _createElementVNode("th", _hoisted_92, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                        _cache[50] || (_cache[50] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createVNode(_component_Sortable, {
                      list: _ctx.requisites.items,
                      "item-key": "id",
                      tag: "tbody",
                      onEnd: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onRequisitesReorder($event))),
                      options: {draggable: '.draggable', handle: '.drag-handle', disabled: !_ctx.reorderEnabled || !(_ctx.isTrader || _ctx.isTraderOperator)}
                    }, {
                      item: _withCtx(({element: item}) => [
                        (_openBlock(), _createElementBlock("tr", {
                          class: "draggable",
                          key: item.id
                        }, [
                          ((_ctx.isTrader || _ctx.isTraderOperator) && _ctx.reorderEnabled)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_93, _cache[51] || (_cache[51] = [
                                _createElementVNode("div", {
                                  class: "drag-handle p-2",
                                  style: {"cursor":"grab"}
                                }, [
                                  _createElementVNode("i", { class: "fa-solid fa-grip-vertical" })
                                ], -1)
                              ])))
                            : _createCommentVNode("", true),
                          (_ctx.isAdmin || _ctx.isOperator)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_94, _toDisplayString(item.id), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_95, [
                                (item.trader)
                                  ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                      key: 0,
                                      user: item.trader
                                    }, null, 8, ["user"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, [
                            _createVNode(_component_DeviceLabel, {
                              device: item.device,
                              "onDevice:updated": _ctx.onDeviceUpdated,
                              "show-id": ""
                            }, null, 8, ["device", "onDevice:updated"])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_96, [
                              _createVNode(_component_PayMethodIcon, {
                                method: item.method
                              }, null, 8, ["method"]),
                              _createElementVNode("div", _hoisted_97, [
                                _createElementVNode("small", _hoisted_98, [
                                  _createTextVNode(_toDisplayString(_ctx.helper.trans('payment_options.' + item.paymentOption)) + " ", 1),
                                  (item.crossBorderCurrency)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(item.crossBorderCurrency), 1))
                                    : _createCommentVNode("", true),
                                  _cache[52] || (_cache[52] = _createTextVNode()),
                                  (item.paymentSystem)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_100, _toDisplayString(_ctx.helper.trans('payment_systems.' + item.paymentSystem)), 1))
                                    : _createCommentVNode("", true),
                                  _cache[53] || (_cache[53] = _createTextVNode()),
                                  (item.p2cConfig?.service_name)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(_ctx.helper.trans(`multitransfer.service.${item.p2cConfig?.service_name}`)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.crossBorderSwift(item.raw))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("small", _hoisted_102, _toDisplayString(item.holderName), 1),
                                      _createElementVNode("span", null, [
                                        _createTextVNode(_toDisplayString(item.requisites) + " ", 1),
                                        _createVNode(_component_copy_button, {
                                          value: item.requisites,
                                          class: "ms-1"
                                        }, null, 8, ["value"])
                                      ]),
                                      _createElementVNode("small", null, _toDisplayString(_ctx.helper.trans('labels.raw_field.swift')) + " " + _toDisplayString(_ctx.crossBorderSwift(item.raw)), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("span", null, [
                                        (item.paymentOption === _ctx.PaymentOption.SBP_QR && item.requisites?.startsWith('http'))
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              href: item.requisites,
                                              target: "_blank"
                                            }, _toDisplayString(_ctx.helper.domain(item.requisites)), 9, _hoisted_103))
                                          : (item.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_104, "—"))
                                            : (item.paymentOption === _ctx.PaymentOption.CLICK_UZ_QR && item.requisites.startsWith('http'))
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 2,
                                                  href: item.requisites,
                                                  target: "_blank"
                                                }, _toDisplayString(_ctx.helper.trans('labels.my_click_uz')), 9, _hoisted_105))
                                              : (item.paymentOption === _ctx.PaymentOption.TIPS && item.requisites.startsWith('http'))
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 3,
                                                    href: item.requisites,
                                                    target: "_blank"
                                                  }, _toDisplayString(_ctx.helper.domain(item.requisites)), 9, _hoisted_106))
                                                : (item.paymentOption === _ctx.PaymentOption.VIET_QR)
                                                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                                      key: 4,
                                                      class: "font-monospace text-break",
                                                      title: _ctx.vietQrEmvFromRaw(item.raw) || undefined
                                                    }, [
                                                      _createTextVNode(_toDisplayString(_ctx.truncateVietQrEmvDisplay(_ctx.vietQrEmvFromRaw(item.raw)) || '—'), 1)
                                                    ], 8, _hoisted_107)), [
                                                      [
                                                        _directive_b_tooltip,
                                                        void 0,
                                                        void 0,
                                                        { hover: true }
                                                      ]
                                                    ])
                                                  : (item.paymentOption === _ctx.PaymentOption.IND_QR)
                                                    ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                                        key: 5,
                                                        class: "font-monospace text-break",
                                                        title: _ctx.qrisEmvFromRaw(item.raw) || undefined
                                                      }, [
                                                        _createTextVNode(_toDisplayString(_ctx.truncateVietQrEmvDisplay(_ctx.qrisEmvFromRaw(item.raw)) || '—'), 1)
                                                      ], 8, _hoisted_108)), [
                                                        [
                                                          _directive_b_tooltip,
                                                          void 0,
                                                          void 0,
                                                          { hover: true }
                                                        ]
                                                      ])
                                                    : (item.paymentOption === _ctx.PaymentOption.BR_QR)
                                                      ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                                          key: 6,
                                                          class: "font-monospace text-break",
                                                          title: _ctx.pixEmvFromRaw(item.raw) || undefined
                                                        }, [
                                                          _createTextVNode(_toDisplayString(_ctx.truncateVietQrEmvDisplay(_ctx.pixEmvFromRaw(item.raw)) || '—'), 1)
                                                        ], 8, _hoisted_109)), [
                                                          [
                                                            _directive_b_tooltip,
                                                            void 0,
                                                            void 0,
                                                            { hover: true }
                                                          ]
                                                        ])
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(item.requisites), 1)),
                                        (item.paymentOption !== _ctx.PaymentOption.MANUAL_SBP_QR)
                                          ? (_openBlock(), _createBlock(_component_copy_button, {
                                              key: 8,
                                              value: item.paymentOption === _ctx.PaymentOption.VIET_QR ? _ctx.vietQrEmvFromRaw(item.raw) : item.paymentOption === _ctx.PaymentOption.IND_QR ? _ctx.qrisEmvFromRaw(item.raw) : item.paymentOption === _ctx.PaymentOption.BR_QR ? _ctx.pixEmvFromRaw(item.raw) : item.requisites,
                                              class: "ms-1"
                                            }, null, 8, ["value"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.hasFrozenSums(item))
                                          ? (_openBlock(), _createBlock(_component_RequisiteFillStatusDot, {
                                              key: 9,
                                              item: item,
                                              class: "ms-2"
                                            }, null, 8, ["item"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("small", _hoisted_111, _toDisplayString(item.holderName), 1)
                                    ], 64)),
                                (item?.deletedAt !== null)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_112, _toDisplayString(_ctx.helper.trans('labels.deleted')), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item.group?.name ?? 'n/a') + " ", 1),
                            (item.group?.trafficGroupIds?.length > 0)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: "fa fa-warning text-warning",
                                  title: _ctx.helper.trans('labels.req_group_traffic_groups_warning', {groups: item.group?.trafficGroupIds.map((id) => _ctx.store.getters['trafficGroups/get'](id)?.name)})
                                }, null, 8, _hoisted_113)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.currency), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_114, [
                              _createElementVNode("div", _hoisted_115, [
                                (!item.minPayInDealSum && !item.maxPayInDealSum)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_116, "n/a"))
                                  : _createCommentVNode("", true),
                                (item.minPayInDealSum)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(_ctx.helper.trans('labels.from_limit', {sum: _ctx.numberFormatter.formatNumber(item.minPayInDealSum), currency: item.minPayInDealSum!.currency })), 1))
                                  : _createCommentVNode("", true),
                                (item.maxPayInDealSum)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_118, _toDisplayString(_ctx.helper.trans('labels.to_limit', {sum: _ctx.numberFormatter.formatNumber(item.maxPayInDealSum), currency: item.maxPayInDealSum!.currency })), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.isAdmin || _ctx.isOperator)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.showEditPayInDealSumsModal(item)),
                                    class: "btn btn-sm btn-link text-nowrap text-capitalize"
                                  }, _cache[54] || (_cache[54] = [
                                    _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)
                                  ]), 8, _hoisted_119))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_120, [
                              _withDirectives((_openBlock(), _createElementBlock("span", {
                                class: "mb-2",
                                title: _ctx.sumTitle('labels.day', item.dayTradesSum, item.dayTradesFrozenSum)
                              }, [
                                (_ctx.hasFrozenSums(item))
                                  ? (_openBlock(), _createBlock(_component_RequisiteSumProgress, {
                                      key: 0,
                                      total: item.dayTradesSum,
                                      frozen: item.dayTradesFrozenSum,
                                      limit: item.dayTradesSumLimit,
                                      active: item.isActive
                                    }, null, 8, ["total", "frozen", "limit", "active"]))
                                  : (_openBlock(), _createBlock(_component_b_progress, {
                                      key: 1,
                                      max: parseInt(item.dayTradesSumLimit.amount),
                                      class: "progress-bar-striped position-relative"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_b_progress_bar, {
                                          value: parseInt(item.dayTradesSum.amount),
                                          class: _normalizeClass(["progress-bar-striped", {'bg-warning': _ctx.isDayLimitReached(item), 'bg-secondary-light': !_ctx.isDayLimitReached(item)}])
                                        }, null, 8, ["value", "class"]),
                                        _createElementVNode("small", _hoisted_122, _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesSum)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesSumLimit)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["max"]))
                              ], 8, _hoisted_121)), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ]),
                              _withDirectives((_openBlock(), _createElementBlock("span", {
                                title: _ctx.sumTitle('labels.month', item.monthTradesSum, item.monthTradesFrozenSum)
                              }, [
                                (_ctx.hasFrozenSums(item))
                                  ? (_openBlock(), _createBlock(_component_RequisiteSumProgress, {
                                      key: 0,
                                      total: item.monthTradesSum,
                                      frozen: item.monthTradesFrozenSum,
                                      limit: item.monthTradesSumLimit,
                                      active: item.isActive
                                    }, null, 8, ["total", "frozen", "limit", "active"]))
                                  : (_openBlock(), _createBlock(_component_b_progress, {
                                      key: 1,
                                      max: parseInt(item.monthTradesSumLimit.amount),
                                      class: "progress-bar-striped position-relative"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_b_progress_bar, {
                                          value: parseInt(item.monthTradesSum.amount),
                                          class: _normalizeClass(["progress-bar-striped", {'bg-warning': _ctx.isMonthLimitReached(item), 'bg-secondary-light': !_ctx.isMonthLimitReached(item)}])
                                        }, null, 8, ["value", "class"]),
                                        _createElementVNode("small", _hoisted_124, _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesSum)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesSumLimit)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["max"]))
                              ], 8, _hoisted_123)), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_125, [
                              _withDirectives((_openBlock(), _createElementBlock("span", {
                                class: "mb-2",
                                title: _ctx.helper.trans('labels.day')
                              }, [
                                _createVNode(_component_b_progress, {
                                  max: item.dayTradesCountLimit,
                                  class: "progress-bar-striped position-relative"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_b_progress_bar, {
                                      value: item.dayTradesCountLimit === 0 ? 0 : item.dayTradesCount,
                                      class: _normalizeClass(["progress-bar-striped", {'bg-warning': item.dayTradesCountLimit > 0 && item.dayTradesCount/item.dayTradesCountLimit >= 0.9, 'bg-secondary-light': item.dayTradesCountLimit === 0 || item.dayTradesCount/item.dayTradesCountLimit < 0.9}])
                                    }, null, 8, ["value", "class"]),
                                    (item.dayTradesCountLimit === 0)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_127, _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesCount)), 1))
                                      : (_openBlock(), _createElementBlock("small", _hoisted_128, _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesCount)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesCountLimit)), 1))
                                  ]),
                                  _: 2
                                }, 1032, ["max"])
                              ], 8, _hoisted_126)), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ]),
                              _withDirectives((_openBlock(), _createElementBlock("span", {
                                title: _ctx.helper.trans('labels.month')
                              }, [
                                _createVNode(_component_b_progress, {
                                  max: item.monthTradesCountLimit,
                                  class: "progress-bar-striped position-relative"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_b_progress_bar, {
                                      value: item.monthTradesCountLimit === 0 ? 0 : item.monthTradesCount,
                                      class: _normalizeClass(["progress-bar-striped", {'bg-warning': item.monthTradesCountLimit > 0 && item.monthTradesCount/item.monthTradesCountLimit >= 0.9, 'bg-secondary-light': item.monthTradesCountLimit === 0 || item.monthTradesCount/item.monthTradesCountLimit < 0.9}])
                                    }, null, 8, ["value", "class"]),
                                    (item.monthTradesCountLimit === 0)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_130, _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesCount)), 1))
                                      : (_openBlock(), _createElementBlock("small", _hoisted_131, _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesCount)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesCountLimit)), 1))
                                  ]),
                                  _: 2
                                }, 1032, ["max"])
                              ], 8, _hoisted_129)), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (item.concurrentTradesCount)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_132, _toDisplayString(_ctx.numberFormatter.formatNumber(item.concurrentTradesCount)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_133, "n/a"))
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_134, [
                              _withDirectives(_createElementVNode("input", {
                                title: item.isActive ? _ctx.helper.trans('requisites.active') : _ctx.helper.trans('requisites.inactive'),
                                "onUpdate:modelValue": ($event: any) => ((item.isActive) = $event),
                                onChange: ($event: any) => (_ctx.toggleRequisitesActivity($event, item)),
                                id: "isActive",
                                class: "form-check-input",
                                style: {"cursor":"pointer"},
                                type: "checkbox",
                                role: "switch"
                              }, null, 40, _hoisted_135), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ],
                                [_vModelCheckbox, item.isActive]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_136, [
                            (item.device && (_ctx.isTrader || _ctx.isTraderOperator || _ctx.isAdmin || _ctx.isOperator))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.$refs.deviceMessageLogsModal.setDevice(item.device)),
                                  class: "btn btn-sm btn-outline-secondary text-nowrap me-2"
                                }, _cache[55] || (_cache[55] = [
                                  _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)
                                ]), 8, _hoisted_137))
                              : _createCommentVNode("", true),
                            (item.isWhiteTriangle && (_ctx.isTrader || _ctx.isTraderOperator || _ctx.isTeamLead) && _ctx.store.getters.getAppData?.fraudexEnabled)
                              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showFraudexFeedbackModal(item)),
                                  title: _ctx.helper.trans('fraudex.leave_feedback'),
                                  class: "btn btn-sm btn-outline-primary text-nowrap me-2"
                                }, _cache[56] || (_cache[56] = [
                                  _createElementVNode("i", { class: "fa fa-comment-dots" }, null, -1)
                                ]), 8, _hoisted_138)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _createCommentVNode("", true),
                            (_ctx.isAdmin || _ctx.isOperator || _ctx.isTrader || _ctx.isTraderOperator)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showHistoryModal(item)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap me-2 text-capitalize"
                                }, _cache[57] || (_cache[57] = [
                                  _createElementVNode("i", { class: "fa fa-list" }, null, -1)
                                ]), 8, _hoisted_139))
                              : _createCommentVNode("", true),
                            (_ctx.isAdmin || _ctx.isOperator)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showEditModal(item)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap me-2 text-capitalize"
                                }, _cache[58] || (_cache[58] = [
                                  _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                                ]), 8, _hoisted_140))
                              : _createCommentVNode("", true),
                            (_ctx.isTrader || _ctx.isTraderOperator)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 4,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showEditModal(item)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap me-2 text-capitalize"
                                }, [
                                  _cache[59] || (_cache[59] = _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                                ], 8, _hoisted_141))
                              : _createCommentVNode("", true),
                            (_ctx.isTrader || _ctx.isTraderOperator)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 5,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.deleteRequisites = item),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                }, [
                                  _cache[60] || (_cache[60] = _createElementVNode("i", { class: "fa fa-trash" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.delete')), 1)
                                ], 8, _hoisted_142))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      ]),
                      _: 1
                    }, 8, ["list", "options"])
                  ]),
                  (_ctx.requisites.totalCount > _ctx.requisites.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[36] || (_cache[36] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[37] || (_cache[37] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.requisites.totalCount,
                        "per-page": _ctx.requisites.limit,
                        limit: 20,
                        "prev-text": _ctx.helper.trans('button.back'),
                        "next-text": _ctx.helper.trans('button.next'),
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_b_modal, {
          title: _ctx.helper.trans('labels.delete_confirm'),
          modelValue: _ctx.deleteRequisites !== null,
          "body-class": "d-none",
          "footer-class": "border-top-0 d-flex justify-content-between",
          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ($event === false && (_ctx.deleteRequisites = null)))
        }, {
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.deleteRequisites = null)),
              class: "btn btn-outline-dark btn-sm text-capitalize"
            }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
            _createVNode(_component_LoaderWrapper, {
              ref: "loaderDeleteRequisites",
              zoom: 0.5
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.confirmRequisitesDelete())),
                  class: "btn btn-outline-danger btn-sm text-capitalize"
                }, _toDisplayString(_ctx.helper.trans('button.delete')), 1)
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["title", "modelValue"]),
        _createVNode(_component_DeviceMessageLogsModal, { ref: "deviceMessageLogsModal" }, null, 512)
      ]),
      _createVNode(_component_BlacklistMethodAgreementModal, {
        "onState:updated": _cache[41] || (_cache[41] = ($event: any) => (_ctx.onBlackListModalUpdated($event))),
        ref: "requisitesConfirmModal"
      }, null, 512),
      _createVNode(_component_TraderRequisitesSettingsModal, { ref: "traderRequisitesSettingsModal" }, null, 512),
      _createVNode(_component_CounterpartiesModal, { ref: "counterpartiesModal" }, null, 512),
      (_ctx.isAdmin || _ctx.isOperator)
        ? (_openBlock(), _createBlock(_component_CounterpartiesImportModal, {
            key: 0,
            ref: "counterpartiesImportModal",
            onImported: _ctx.onCounterpartiesImported
          }, null, 8, ["onImported"]))
        : _createCommentVNode("", true),
      (_ctx.store.getters.getAppData?.fraudexEnabled)
        ? (_openBlock(), _createBlock(_component_FraudexCheckModal, {
            key: 1,
            visible: _ctx.fraudexCheckModal,
            "onUpdate:visible": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.fraudexCheckModal) = $event)),
            "fraudex-check": _ctx.fraudexCheckData?.fraudexCheck || null,
            onContinue: _ctx.handleFraudexCheckContinue,
            onCancel: _ctx.handleFraudexCheckCancel
          }, null, 8, ["visible", "fraudex-check", "onContinue", "onCancel"]))
        : _createCommentVNode("", true),
      (_ctx.store.getters.getAppData?.fraudexEnabled)
        ? (_openBlock(), _createBlock(_component_FraudexFeedbackModal, {
            key: 2,
            visible: _ctx.fraudexFeedbackModal,
            "onUpdate:visible": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.fraudexFeedbackModal) = $event)),
            requisite: _ctx.fraudexFeedbackRequisite?.requisites || '',
            onSubmit: _ctx.handleFraudexFeedbackSubmit
          }, null, 8, ["visible", "requisite", "onSubmit"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}